var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ant-design:x-outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 27.4719L18.6145 13.792L18.6305 13.8049L27.0929 4H24.265L17.3713 11.9804L11.8968 4H4.48021L13.2425 16.7719L13.2414 16.7708L4 27.4719H6.82792L14.4921 18.5931L20.5834 27.4719H28ZM10.7763 6.1338L23.9449 25.3381H21.7039L8.5247 6.1338H10.7763Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterXIcon);
export default __webpack_public_path__ + "static/media/footer_x_icon.a38a5404c016e52a8bc64f7ff651b3f2.svg";
export { ForwardRef as ReactComponent };